/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneJwVideoTeaser from 'base/components/standalone/JwVideo/Teaser';

export const DynamicStandaloneJwVideoTeaser = StandaloneJwVideoTeaser;
export type DynamicStandaloneJwVideoTeaserProps = PropsFromComponent<typeof StandaloneJwVideoTeaser>;

export const DynamicStandaloneJwVideoTeaserWith = (extras: DynamicStandaloneExtras): typeof StandaloneJwVideoTeaser => {
    return function DynamicStandaloneJwVideoTeaser(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'JwVideoTeaser');
        return <StandaloneJwVideoTeaser {...mergeProps({ options: { theme } }, props)} />;
    }
}